import React, { useState } from "react";
import { Table, Card, Button, Modal, Select, Form, Row, Col, InputNumber, Tooltip } from "antd";
import useLearners from  "PlatForms/OrgLMS/Hooks/ManagerHooks/useLearners";
import { useNavigate } from "react-router-dom";
import usePerformanceReviewForm from  "PlatForms/OrgLMS/Hooks/ManagerHooks/usePerformanceReview";
import api from "Common/Client/Interceptor";
import { useContext } from "react";
import { ProfileContext } from "Common/hooks/context/ProfileContext";
const { Option } = Select;
const EmployeeGroup = () => {
  const { isProfileComplete } = useContext(ProfileContext);
  const isBlocked = !isProfileComplete;
  const managerId = localStorage.getItem("personalId");
  const token = localStorage.getItem("token");
  const { learners, loading } = useLearners(managerId);
  const { recommendCourses } = usePerformanceReviewForm();
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedLearner, setSelectedLearner] = useState(null);
  const [form] = Form.useForm();
  const [submitLoading, setSubmitLoading] = useState(false);
  const [isBudgetYes, setIsBudgetYes] = useState(false);
  const handleBudgetChange = (value) => {
    if (isBlocked) return;
    setIsBudgetYes(value === true);
  };
  const showModal = (learner) => {
    if (isBlocked) return;
    setSelectedLearner(learner);
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };
  const handleSubmit = async (values) => {
    if (isBlocked) return;
    setSubmitLoading(true);
    try {
      await api.post("/TrainingRequest/Manager/Create", {
        learnerId: selectedLearner.learnerId,
        courseId: values.courseId,
        isBudgetAllocated: values.isBudgetAllocated,
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      handleCancel();
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setSubmitLoading(false);
    }
  };
  const handleNavigation = (path, state) => {
    if (isBlocked) return;
    navigate(path, { state });
  };
  const columns = [
    {
      title: "Name",
      render: (text, record) => `${record.firstName} ${record.lastName}`,
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Phone",
      dataIndex: "phoneNo",
      render: (text) => (text ? text : "N/A"),
    },
    {
      title: "Business Group Name",
      dataIndex: "businessGroupName",
      render: (text) => (text ? text : "N/A"),
    },
    {
      title: "Assigned Date",
      dataIndex: "managerAssignedDate",
      render: (date) => (date ? new Date(date).toLocaleString() : "N/A"),
    },
  ];
  return (
    <>
      <Card
        title="Employee List"
        loading={loading}
        style={{ opacity: isBlocked ? 0.6 : 1 }}
      >
        <Table
          rowKey="learnerId"
          dataSource={learners}
          columns={columns.filter(col => col.title !== "Actions")}
          pagination={{ pageSize: 5 }}
          expandable={{
            expandedRowRender: (record) => {
              const isDisabled = !record.businessGroupName || isBlocked;
              const tooltipText = isDisabled ?
                (!record.businessGroupName ? "No Business Group assigned" : "Complete your profile first")
                : "";
              return (
                <div style={{ display: 'flex', marginLeft: '50px', flexWrap: 'wrap', gap: '12px' }}>
                  <Tooltip title={tooltipText}>
                    <Button
                      onClick={() => handleNavigation("/training-recomends", {
                        learnerId: record.learnerId
                      })}
                      disabled={isDisabled}
                      style={{
                        opacity: isDisabled ? 0.6 : 1,
                        backgroundColor: '#1b4d5dff',
                        borderColor: '#1b4d5dff',
                        color: '#fff'
                      }}
                    >
                      Recommend Training
                    </Button>
                  </Tooltip>
                  <Tooltip title={isBlocked ? "Complete your profile first" : ""}>
                    <Button
                      type="primary"
                      onClick={() => handleNavigation("/check-reviews", {
                        learnerId: record.learnerId,
                        firstName: record.firstName,
                        lastName: record.lastName
                      })}
                      disabled={isBlocked}
                      style={{
                        opacity: isDisabled ? 0.6 : 1,
                        backgroundColor: '#1b4d5dff', // Sea Green
                        borderColor: '#1b4d5dff',
                        color: '#fff'
                      }}
                    >
                      Performance Review
                    </Button>
                  </Tooltip>
                  <Tooltip title={isDisabled ? tooltipText : ""}>
                    <Button
                      type="primary"
                      disabled={isDisabled}
                      onClick={() => handleNavigation("/perfomance-review-disc-assessment", {
                        learnerId: record.learnerId,
                        firstName: record.firstName,
                        lastName: record.lastName
                      })}
                      style={{
                        opacity: isDisabled ? 0.6 : 1,
                        backgroundColor: '#1b4d5dff', // Sea Green
                        borderColor: '#1b4d5dff',
                        color: '#fff'
                      }}
                    >
                      DISC+PerformanceRev
                    </Button>
                  </Tooltip>
                </div>
              );
            }
          }}
        />
      </Card>
      <Modal
        title="Recommend Training"
        open={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        centered
      >
        <Form layout="vertical" onFinish={handleSubmit} form={form}>
          <Form.Item
            name="courseId"
            label="Recommend Training"
            rules={[{ required: true, message: "Please select a course" }]}
          >
            <Select
              placeholder="Select a course"
              disabled={isBlocked}
            >
              {recommendCourses.map((course) => (
                <Option key={course.id} value={course.id}>
                  {course.title}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="Is Budget Allocated"
            name="isBudgetAllocated"
            rules={[{ required: true, message: "Please select budget allocation status!" }]}
          >
            <Select
              placeholder="Select Yes or No"
              onChange={handleBudgetChange}
              disabled={isBlocked}
            >
              <Option value={true}>Yes</Option>
              <Option value={false}>No</Option>
            </Select>
          </Form.Item>
          {isBudgetYes && (
            <Row gutter={16}>
              <Col xs={16}>
                <Form.Item label="Budget Amount" name="budgetAmount">
                  <InputNumber
                    placeholder="Enter amount"
                    style={{ width: "100%" }}
                    min={0}
                    step={0.01}
                    stringMode
                    disabled={isBlocked}
                  />
                </Form.Item>
              </Col>
            </Row>
          )}
          <Form.Item style={{ marginTop: 20 }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={submitLoading}
              disabled={isBlocked}
            >
              Submit
            </Button>
            <Button onClick={handleCancel} style={{ marginLeft: 10 }}>
              Cancel
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
export default EmployeeGroup;